import { cva } from "class-variance-authority"

export const inputBaseVariants = cva(
  "flex w-full rounded-md transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      variant: {
        outline:
          "border border-input bg-transparent shadow-sm focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
        secondary:
          "border border-transparent bg-secondary text-secondary-foreground shadow-sm focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
        ghost:
          "border border-transparent bg-transparent focus-visible:border-input focus-visible:shadow-sm",
      },
      size: {
        tiny: "h-6 px-2 py-0.5 text-xs rounded-sm",
        xs: "h-7 px-2 py-0.5 text-sm rounded-sm",
        sm: "h-8 px-3 py-1 text-sm rounded-sm",
        md: "h-9 px-3 py-1 text-sm",
        lg: "h-10 px-4 py-2 text-base",
      },
    },
    defaultVariants: {
      variant: "outline",
      size: "md",
    },
  },
)
